export const ROUTES = {
  HOME: '/',
  CATEGORY: '/category/:id',
  EXERCISE: '/exercise/:categoryId/:exerciseId',
} as const;

export const buildCategoryPath = (id: string): string => `/category/${id}`;
export const buildExercisePath = (categoryId: string, exerciseId: string): string =>
  `/exercise/${categoryId}/${exerciseId}`;
